<template>
    <div class="license-assign">
        <popup-panel> </popup-panel>

        <!-- MANAGER CONTAINER -->
        <div class="license-assign__subscription-manager">
            <subscription-manager :licenseAssignement="true" />
        </div>

        <div class="license-assign__buttons-container">
            <CompassButton
                :label="
                    choseALicense ? labels.buttons.cancel : labels.buttons.back_choose_admin_license
                "
                type="secondary"
                @click="goBack"
            />

            <CompassButton
                v-if="choseALicense"
                :label="labels.buttons.continue"
                :disabled="isContinueButtonDisabled"
                @click="goToUrl('/home')"
            />
            <CompassButton v-else :label="labels.buttons.disconnect" @click="goToUrl('/logout')" />
        </div>
    </div>
</template>

<script>
import { goToUrl } from 'vueDir/helpers.js';
import SubscriptionManager from 'vcomponents/sellsyaccountmanager/SubscriptionManager.vue';
import PopupPanel from 'vcomponents/PopupPanel.vue';
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('subscriptionManager');
const { mapState: mapStateUser } = createNamespacedHelpers('user');
const noLicenseValue = 'null';

export default {
    components: {
        SubscriptionManager,
        PopupPanel,
    },
    props: {
        licenseChosen: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            labels: {
                buttons: {
                    cancel: this.$l10n.__('Annuler'),
                    continue: this.$l10n.__('Continuer vers Sellsy'),
                    back_choose_admin_license: this.$l10n.__(
                        'Vous souhaitez vous attribuer une licence ?',
                    ),
                    disconnect: this.$l10n.__('Se déconnecter'),
                },
            },
        };
    },
    computed: {
        ...mapState(['staffs']),
        ...mapStateUser({
            staffId: 'id',
        }),
        choseALicense() {
            return this.licenseChosen && this.licenseChosen !== noLicenseValue;
        },
        isContinueButtonDisabled() {
            return this.staffs.some(
                (staff) => staff.id === this.staffId && staff.license === noLicenseValue,
            );
        },
    },
    methods: {
        goToUrl,
        goBack() {
            this.$emit('back');
        },
    },
};
</script>

<style lang="scss" scoped>
.license-assign {
    padding-bottom: 96px;

    &__subscription-manager {
        max-width: 1120px;
        padding: var(--spacing-5);
        border-radius: 4px;
        border: 1px solid var(--colors-common-border-default);
        background-color: var(--colors-common-background-default);
    }

    &__buttons-container {
        position: fixed;
        z-index: 1;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: var(--spacing-1);
        padding: var(--spacing-3) var(--spacing-5);
        background-color: var(--colors-common-background-default);
        box-shadow: 0px 0px 12px 0px rgba(17, 17, 17, 0.24);
    }
}
</style>
